import Vue from "vue";
import Vuex from "vuex";
import HomeDataStore from "./HomeData/HomeDataStore";
import WriteDataStore from "./WriteData/WriteDataStore";
import NewTravelStore from "./NewTravel/NewTravelStore";
import PersonalStore from "./Personal/PersonalStore";
import CheckDataStore from "./CheckData/CheckDataStore";
import MessageStore from "./Message/MessageStore";


Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    HomeDataStore, //home页10条游记数据.
    WriteDataStore,
    NewTravelStore, //最新游记
    PersonalStore,
    CheckDataStore,
    MessageStore,
  }
});
